import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const BannerSection = styled.div`
    width: 100%;
    background-color: ${COLORS.BgSurface};
    flex-direction: column;
    padding: 24px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    overflow: hidden;
    position: relative;
    z-index: 2;

    @media (max-width: ${wideBreakpoints.tablet}) {
        border-radius: ${BorderRadius.componentRadius};
    }
`;

export const Image = styled(LazyLoadImage)`
    position: absolute;
    margin: auto;
    right: 0;
    top: 40px;
    bottom: 0;
    max-height: 100%;
    z-index: -1;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        left: 61%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        right: 40px;
        top: 10px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        left: 60%;
        right: 0;
    }
`;

export const InfoBlock = styled.div`
    flex-direction: column;
`;

export const Title = styled.div`
    max-width: 174px;
    ${FONTS.H3};
    margin-bottom: 4px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H4};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        max-width: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: 174px;
    }
`;

export const Subtitle = styled.div`
    ${FONTS.S};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        width: 195px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.XS};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: auto;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 195px;
    }
`;

export const ButtonBlock = styled.div`
    gap: 12px;
    margin-top: 16px;
    flex-direction: column;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    > a {
        width: fit-content;
    }
`;
